import React from 'react';

import './index.less';

import { getCheckDisplayName, getCheckSummaryItems, ICheckStep } from '../../shared/utils';

import BaseCheckListItem, { ICheckListItemCommonProps } from './BaseCheckListItem';

export interface ICheckListItemProps extends ICheckListItemCommonProps {
  step: ICheckStep;
}

const CheckListItem: React.FC<ICheckListItemProps> = ({ step, ...props }) => {
  return (
    <BaseCheckListItem
      {...props}
      step={step}
      summaryItems={getCheckSummaryItems(step)}
      title={getCheckDisplayName(step.check)}
    />
  );
};

export default CheckListItem;
